import { render } from "./CheckboxWeekDays.vue?vue&type=template&id=0fdc54d0&ts=true"
import script from "./CheckboxWeekDays.vue?vue&type=script&lang=ts"
export * from "./CheckboxWeekDays.vue?vue&type=script&lang=ts"

import "./CheckboxWeekDays.vue?vue&type=style&index=0&id=0fdc54d0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__